import { provideLazy } from '@/rule/injections.ts';
import { RULES_REPOSITORY } from '@/rule/RuleKeys.ts';
import { key, piqure } from 'piqure';
import { type AuthenticatedFetcher, buildFetcher } from '@/generic/authentication';
import { RulesCleanAPIHttp } from '@/rule/secondary/RulesCleanAPIHttp.ts';

const FETCHER = key<AuthenticatedFetcher>('Rule fetcher');

const local = piqure();

export const provideRule = () => {
  local.provideLazy(FETCHER, () => buildFetcher());
  provideLazy(RULES_REPOSITORY, () => new RulesCleanAPIHttp(local.inject(FETCHER)));
};
